import history from 'App/pages/routes/history';
import MailTemplateBrowser from 'App/upsales/common/components/react/mailTemplateBrowser';
import CreateGroupMail from 'Components/CreateGroupMail/CreateGroupMail';
import { checkPortedResolve } from 'App/helpers/angularRouteHelpers';

angular.module('domain.mail', ['upResources', 'security.authorization', 'ui.router']).config([
	'$routeGuardProvider',
	'$stateProvider',
	'$upModalProvider',
	function ($routeGuardProvider, $stateProvider, $upModalProvider) {
		authUser.$inject = ['$routeGuard'];
		mapMailActivated.$inject = ['$routeGuard', '$stateParams', '$upModal', '$state', '$q'];
		function authUser($routeGuard) {
			return $routeGuard.requireUser();
		}

		function mapMailActivated($routeGuard, $stateParams, $upModal, $state, $q) {
			var promise = $q.defer();

			$routeGuard
				.mapMailActivated($stateParams)
				.then(function () {
					promise.resolve();
				})
				.catch(function () {
					// eslint-disable-next-line
					$upModal
						.open('warningConfirm', {
							icon: 'fa-warning',
							title: 'default.warning',
							body: 'default.featureNotActivated',
							resolveTrue: 'navbar.settings'
						})
						.then(function () {
							history.push('/admin/mailsettings');
						});

					promise.reject();
				});

			return promise.promise;
		}

		$stateProvider
			.state('mailCampaign', {
				abstract: true,
				templateUrl: require('App/upsales/domain/mail/views/mailCampaign.html?file'),
				url: '/:customerId/mail-campaign/:id/',
				controller: 'MailCampaign as MailCampaignCtrl',
				section: 'market',
				resolve: {
					authUser: authUser,
					app: [
						'AppService',
						function (AppService) {
							return checkPortedResolve('mailCampaign', () => AppService.loadedPromise);
						}
					],
					authRights: [
						'$routeGuard',
						'$stateParams',
						function ($routeGuard, $stateParams) {
							return checkPortedResolve('mailCampaign', () =>
								$routeGuard.requireAdminOrMailAdmin($stateParams)
							);
						}
					],
					meta: [
						'MailCampaignMeta',
						'$stateParams',
						'$state',
						function (MailCampaignMeta, $stateParams) {
							return checkPortedResolve('mailCampaign', () => {
								var promise = MailCampaignMeta($stateParams);
								promise.catch(function () {
									history.replace('/mail-campaigns');
								});
								return promise;
							});
						}
					],
					campaignMeta: [
						'MailCampaignInfo',
						'$stateParams',
						'NotificationService',
						function (MailCampaignInfo, $stateParams, NotificationService) {
							return checkPortedResolve('mailCampaign', () =>
								MailCampaignInfo.get($stateParams.id)
							).catch(err => {
								if (err?.status === 403) {
									NotificationService.addNotification({
										title: 'default.error',
										body: 'errorNotFound.mailCampaign',
										style: 'error',
										icon: 'times'
									});
								}
							});
						}
					]
				}
			})
			.state('mailCampaign.dashboard', {
				template: '',
				url: '',
				controller: 'MailCampaignDashboard as MailCampaignSub',
				section: 'market'
			})
			.state('mailCampaign.visits', {
				template: '',
				url: 'visits',
				controller: 'MailCampaignVisits as MailCampaignSub',
				section: 'market'
			})
			.state('mailCampaign.submits', {
				template: '',
				url: 'submits',
				controller: 'MailCampaignSubmits as MailCampaignSub',
				section: 'market'
			})
			.state('mailCampaign.recipients', {
				template: '',
				url: 'recipients?filter&drill',
				controller: 'MailCampaignRecipients as MailCampaignSub',
				section: 'market'
			})
			.state('listMailTemplates', {
				url: '/:customerId/mail/templates/'
			});

		$upModalProvider
			.modal('mailTemplateBrowser', {
				template: '<div id="mailTemplateBrowser"></div>',
				controller: function ($scope, $modalParams, $rootScope) {
					let rootNode;
					var renderTimeout;
					var tools = {
						$rootScope: $rootScope
					};

					var render = function () {
						if (renderTimeout) {
							clearTimeout(renderTimeout);
						}
						renderTimeout = setTimeout(function () {
							rootNode = document.getElementById('mailTemplateBrowser');
							if (!rootNode) {
								return;
							}

							ReactDOM.render(
								React.createElement(MailTemplateBrowser, {
									// Data and stuff
									tools: tools,

									closeModal: $scope.reject,
									onSelect: $scope.resolve,
									$modalParams: $modalParams
								}),
								rootNode,
								function () {}
							);
						}, 20);
					};

					$scope.$on('$destroy', function () {
						ReactDOM.unmountComponentAtNode(rootNode);
						rootNode = undefined;
					});

					render();
				},
				style: 'form default bg-gray'
			})
			.modal('createGroupMail', {
				template: '<div></div>',
				controller: function ($scope, $element, $modalParams) {
					window.SetupComponent($scope, CreateGroupMail, $element[0], $modalParams, { modal: true });
				},
				style: 'form-wide default new-full-screen'
			});
	}
]);
